import Checkmark from '@CS/assets/checkmark.svg?no-inline';
import styled, { css } from 'styled-components';

export const OnboardingContent = styled.div`
  padding: 40px 20px 30px;
  text-align: center;

  > p {
    margin-block: 22px 30px;
  }

  > div {
    margin-bottom: 30px;

    label {
      justify-content: center;
      align-items: center;
      display: flex;
    }
  }
`;

type CheckboxAttributes = {
  checked?: boolean;
};

export const Checkbox = styled.input(
  ({ checked }: CheckboxAttributes) => css`
    margin-right: 11px;
    position: relative;
    overflow: hidden;
    border: none;
    height: 28px;
    width: 28px;

    &::after {
      transition: background-color 0.3s;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      pointer-events: none;
      position: absolute;
      display: block;

      height: 100%;
      width: 100%;
      content: '';

      ${checked &&
      css`
        background-image: url(${Checkmark});
        background-color: #ffbc0d;
        background-position: center;
        border: 1px solid #292929;
        background-size: 60%;
        border-radius: 5px;
      `}
    }
  `
);
